const formatDate = (dateText) => {
  const [year, month, day] = dateText.split("-");
  return `${day}/${month}/${year}`;
};

export const getReportPeriod = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return { valid: false, label: "" };
  }

  return {
    valid: true,
    label: `From: ${formatDate(startDate)} To: ${formatDate(endDate)}`,
  };
};

export const getSalesPrintHeaderHtml = (type, periodLabel) => {
  const title =
    type === "total"
      ? "Sales Ledger Summary"
      : `${type.charAt(0).toUpperCase() + type.slice(1)} Ledger Summary`;

  return `<h2>${title}</h2><p>${periodLabel}</p>`;
};

export const getSalesPrintSections = (
  type,
  { foodSales, wineSales, beerSales, paymentHtml, tableHtml }
) => {
  if (type === "food") {
    return `<h3>Food Sales Summary</h3>${tableHtml(foodSales)}`;
  }
  if (type === "wine") {
    return `<h3>Wine Sales Summary</h3>${tableHtml(wineSales)}`;
  }
  if (type === "beer") {
    return `<h3>Beer Sales Summary</h3>${tableHtml(beerSales)}`;
  }
  if (type === "total") {
    return (
      `<h3>Food Sales Summary</h3>${tableHtml(foodSales)}` +
      `<h3>Wine Sales Summary</h3>${tableHtml(wineSales)}` +
      `<h3>Beer Sales Summary</h3>${tableHtml(beerSales)}` +
      `<h3>Payment Summary</h3>${paymentHtml}`
    );
  }
  return "";
};
